import { combineReducers } from "redux";
import overviewReportReducer from "agency/reports/overview/reducer";
//-- Reducer -------------------------------------------------------------------------------------------------------------------------------
export const agencyReportsReducer = combineReducers({
    overviewReport: overviewReportReducer
});
